<template>
  <div>
    <v-card-title>
      <h6>
        {{ $tt('customFieldHeader') }}
      </h6>
    </v-card-title>
    <v-card-text>
      <v-select
        v-model="pks"
        :items="fieldsWithNameAndMine"
        item-text="name"
        :itemValue="fieldValue"
        label=""
        :multiple="multiple"
        chips
        :hint="$tt('customPlantingFieldSelectionHint')"
        persistent-hint
        :error="error"
        :errorMessages="errorMessage"
      />
    </v-card-text>
  </div>
</template>

<script>
import UserInfo from '@/lib/user-info'

export default {
  name: 'MyFieldSelectComponent',
  props: {
    multiple: { type: Boolean, required: true },
    value: { required: true },
    error: { type: Boolean },
    errorMessage: { type: String },
    fieldValue: { type: String, default: 'pk' }, // FIXME pk参照だと同期したときに変更される場合があるので、id参照にすべき
  },
  computed: {
    fieldsWithNameAndMine() {
      const me = UserInfo.getUsername()
      return this.$store.getters.fields.filter(f => f.name).filter(f => f.username === me)
    },

    pks: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      },
    },
  },
}
</script>
